/**
 * Centralized ReactFlow key/gesture bindings for the workspace canvas.
 *
 * ReactFlow expresses several shortcuts as component props rather than keydown handlers. We
 * hoist those prop VALUES here so the bindings are catalogable and carry SHORTCUT_ID markers
 * (see keyboardShortcuts.ts anti-staleness contract + keyboardShortcutsCoverage.test.ts).
 *
 * If you change any of these, update keyboardShortcuts.ts (the Keyboard Shortcuts modal).
 */

// ReactFlow's built-in delete is disabled; deletion is owned by the custom keydown handler
// in WorkspacePageV2 (SHORTCUT_ID: canvas.delete). null = no built-in delete key.
export const CANVAS_DELETE_KEY_CODE = null

// Box-select (canvas.boxSelect) is intentionally NOT a ReactFlow selectionKeyCode. Dreamwrite owns
// Shift-selection via its own `isShiftSelecting` state (see WorkspacePageV2 shift tracker) and drives
// it through `selectionOnDrag={isShiftSelecting}` with `selectionKeyCode={null}`, so ReactFlow's
// internal Shift latch (which lacks missed-key reconciliation) can't independently stick the canvas
// in selection mode. The canvas.boxSelect SHORTCUT_ID marker therefore lives next to
// `selectionOnDrag` in WorkspacePageV2.

// SHORTCUT_ID: canvas.multiSelect — hold Cmd/Ctrl and click to add nodes to the selection.
export const CANVAS_MULTI_SELECTION_KEY_CODE = ['Meta', 'Control']

// The following canvas gestures are ReactFlow built-ins toggled by boolean props in
// WorkspacePageV2's <ReactFlow>. Their SHORTCUT_ID markers live next to those props:
//   SHORTCUT_ID: canvas.zoomInDoubleClick / canvas.zoomOutDoubleClick  (zoomOnDoubleClick)
//   SHORTCUT_ID: canvas.zoomPinch                                      (zoomOnPinch)
//   SHORTCUT_ID: canvas.pan                                            (panOnScroll / panOnDrag)
//   SHORTCUT_ID: canvas.boxSelect                                      (selectionOnDrag)
